import * as React from "react"
import { SVGProps } from "react"
const HundIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 520" {...props}>
        <path
            d="M380 349c-4 6-9 12-15 15a112.36 112.36 0 0 0-28 16c3-1 6-4 9-5 14-2 26-7 35-18a7.44 7.44 0 0 0 1-9 3.49 3.49 0 0 1-2 1Z"
            className="a"
        />
        <path
            d="M380 349c-4 6-9 12-15 15a112.36 112.36 0 0 0-28 16c3-1 6-4 9-5 14-2 26-7 35-18a7.44 7.44 0 0 0 1-9 3.49 3.49 0 0 1-2 1Z"
            className="b"
        />
        <path
            d="M409 245c-5-8-16-7-24-10-44 3-87 6-132 12a158.31 158.31 0 0 0-31 9c-1 0-1 2-2 2a23.84 23.84 0 0 0-11 6c-1 1-2 0-3 1-28 19-39 58-17 85 1 1 0 2 1 3 2 2 4 5 6 7 4 3 6 6 9 9 16 13 33 23 53 26 7-2 15-2 22-4-14 0-28-2-41-7-5-3-10-4-14-7-4-4-9-6-13-9-2-1-3-4-4-5-11-8-17-18-22-30-5-13-4-27 1-40 4-10 12-17 20-24 6-4 13-7 19-10 10-4 20-6 31-8h6a27.69 27.69 0 0 1 9-1c40-3 79-9 119-9a23.89 23.89 0 0 1 14 5c1 1 1 3 3 3 1-1 1-3 1-4Z"
            className="a"
        />
        <path
            d="M409 245c-5-8-16-7-24-10-44 3-87 6-132 12a158.31 158.31 0 0 0-31 9c-1 0-1 2-2 2a23.84 23.84 0 0 0-11 6c-1 1-2 0-3 1-28 19-39 58-17 85 1 1 0 2 1 3 2 2 4 5 6 7 4 3 6 6 9 9 16 13 33 23 53 26 7-2 15-2 22-4-14 0-28-2-41-7-5-3-10-4-14-7-4-4-9-6-13-9-2-1-3-4-4-5-11-8-17-18-22-30-5-13-4-27 1-40 4-10 12-17 20-24 6-4 13-7 19-10 10-4 20-6 31-8h6a27.69 27.69 0 0 1 9-1c40-3 79-9 119-9a23.89 23.89 0 0 1 14 5c1 1 1 3 3 3 1-1 1-3 1-4Z"
            className="b"
        />
        <path
            d="M221 265c-1 0-3 0-4 1 0 1 1 2 1 3-21 7-36 25-38 47-2 13 1 28 11 38-1 1-2 2 0 4a3.67 3.67 0 0 0 3 1c23-6 44-23 48-47a44.24 44.24 0 0 0-3-32 21.86 21.86 0 0 1-3-5c-4-5-8-10-15-10Z"
            className="a"
        />
        <path
            d="M224 303c-5-3-11 2-11 6 1 8-4 15-12 18-5 1-11 10-4 13 11 5 23-5 29-15 3-7 6-17-2-22Z"
            className="a"
        />
        <path
            d="M224 303c-5-3-11 2-11 6 1 8-4 15-12 18-5 1-11 10-4 13 11 5 23-5 29-15 3-7 6-17-2-22Z"
            className="b"
        />
        <path
            d="M326 328h-3c-1 4 2 8 2 12 0 6-3 11-7 15-8 8-20 9-31 7-1 0-2 2-1 3 8 9 20 5 29-1 4-3 10-5 12-11 1-2 2-5 3-7 1-6 0-13-4-18Z"
            className="a"
        />
        <path
            d="M326 328h-3c-1 4 2 8 2 12 0 6-3 11-7 15-8 8-20 9-31 7-1 0-2 2-1 3 8 9 20 5 29-1 4-3 10-5 12-11 1-2 2-5 3-7 1-6 0-13-4-18Z"
            className="b"
        />
        <path
            d="M343 251c-5-2-12 1-14 6a10.86 10.86 0 1 0 21 5 9.21 9.21 0 0 0-7-11Z"
            className="a"
        />
        <path
            d="M343 251c-5-2-12 1-14 6a10.86 10.86 0 1 0 21 5 9.21 9.21 0 0 0-7-11Z"
            className="b"
        />
        <path
            d="M310 241c-1-6-4-11-10-11-4 1-8 2-10 5-1 3-4 5 0 9 6-3 13-1 20-3Z"
            className="a"
        />
        <path
            d="M310 241c-1-6-4-11-10-11-4 1-8 2-10 5-1 3-4 5 0 9 6-3 13-1 20-3Z"
            className="b"
        />
        <path
            d="M418 190c-18 10-29 29-34 48-1 3-3 7 2 10 17-2 34 4 51 2 26-4 38-35 24-57-10-14-30-12-43-3ZM335 255c-1 1-3 1-4 2a4 4 0 0 0 5 5 2.15 2.15 0 0 0 2-2c0-2 0-4-3-5Z"
            className="a"
        />
        <path
            d="M335 255c-1 1-3 1-4 2a4 4 0 0 0 5 5 2.15 2.15 0 0 0 2-2c0-2 0-4-3-5Z"
            className="b"
        />
        <path
            d="M338 263c-1 1-2 1-2 2v2c1 1 2 2 4 0v-3a3.49 3.49 0 0 0-2-1Z"
            className="a"
        />
        <path
            d="M338 263c-1 1-2 1-2 2v2c1 1 2 2 4 0v-3a3.49 3.49 0 0 0-2-1Z"
            className="b"
        />
        <path d="M342 260c-1 0-1 1-2 1l1 1c1 0 1-1 2-1l-1-1Z" className="a" />
        <path d="M342 260c-1 0-1 1-2 1l1 1c1 0 1-1 2-1l-1-1Z" className="b" />
        <path
            d="M298 235c-1-1-3 0-4 2-1 1 0 3 1 4 2 0 4 1 6-2 1-1 0-3-1-4Z"
            className="a"
        />
        <path
            d="M298 235c-1-1-3 0-4 2-1 1 0 3 1 4 2 0 4 1 6-2 1-1 0-3-1-4Z"
            className="b"
        />
        <path
            d="M305 239c-1 0-1 1-2 1 0 1 1 1 1 2 1-1 2-1 2-2l-1-1Z"
            className="a"
        />
        <path
            d="M305 239c-1 0-1 1-2 1 0 1 1 1 1 2 1-1 2-1 2-2l-1-1Z"
            className="b"
        />
        <path
            d="M678 291c1-26-6-53-29-69-9-5-19-8-30-6-34 6-59 27-87 48-24 17-52 31-82 23h-4c-6-3-13-6-18-11-4-4-7-10-9-15a133.55 133.55 0 0 0-7-18c-3-4-8-8-13-5-1 1 0 3 1 3 5 0 8 4 10 7 4 9 5 18 10 27a47.19 47.19 0 0 0 31 18c29 5 54-6 78-21 3-3 7-4 10-7 2-2 4-3 7-5 13-12 28-21 43-29 2-1 5-2 7-3 12-3 23-9 36-7s24 11 30 23c18 37 16 89-18 117-2 1-3 1-5 3-1 1-3 1-5 2-1 0-1 2-2 2-6 2-12 2-17 4-1 1-2 3 0 3 22 3 41-13 51-32 2-4 3-7 5-11 5-13 7-27 7-41Z"
            className="a"
        />
        <path
            d="M678 291c1-26-6-53-29-69-9-5-19-8-30-6-34 6-59 27-87 48-24 17-52 31-82 23h-4c-6-3-13-6-18-11-4-4-7-10-9-15a133.55 133.55 0 0 0-7-18c-3-4-8-8-13-5-1 1 0 3 1 3 5 0 8 4 10 7 4 9 5 18 10 27a47.19 47.19 0 0 0 31 18c29 5 54-6 78-21 3-3 7-4 10-7 2-2 4-3 7-5 13-12 28-21 43-29 2-1 5-2 7-3 12-3 23-9 36-7s24 11 30 23c18 37 16 89-18 117-2 1-3 1-5 3-1 1-3 1-5 2-1 0-1 2-2 2-6 2-12 2-17 4-1 1-2 3 0 3 22 3 41-13 51-32 2-4 3-7 5-11 5-13 7-27 7-41Z"
            className="b"
        />
        <path
            d="M611 212c-3-11-10-20-17-30-1-1-2-1-3-2-4-7-10-11-15-17-1-1-2 0-3-1-19-17-51-22-70-3v2c7-1 11-6 17-8a53 53 0 0 1 33 2c25 12 42 35 53 60 0 0 3-2 5-3Z"
            className="a"
        />
        <path
            d="M611 212c-3-11-10-20-17-30-1-1-2-1-3-2-4-7-10-11-15-17-1-1-2 0-3-1-19-17-51-22-70-3v2c7-1 11-6 17-8a53 53 0 0 1 33 2c25 12 42 35 53 60 0 0 3-2 5-3Z"
            className="b"
        />
        <path
            d="M637 172c4 15 2 30-7 43 3 1 5 1 8 2 0-3 2-5 3-7 10-29 0-63-25-83-22-17-49-19-74-10a66.71 66.71 0 0 0-40 42h2c12-15 21-32 40-38 23-8 49-5 69 10 1 1 1 2 2 3 12 10 17 24 22 38Z"
            className="a"
        />
        <path
            d="M637 172c4 15 2 30-7 43 3 1 5 1 8 2 0-3 2-5 3-7 10-29 0-63-25-83-22-17-49-19-74-10a66.71 66.71 0 0 0-40 42h2c12-15 21-32 40-38 23-8 49-5 69 10 1 1 1 2 2 3 12 10 17 24 22 38Z"
            className="b"
        />
        <path
            d="M578 127c-2-3-6-4-10-4 3-2 7-3 8-7a3.49 3.49 0 0 0-1-2c-17 2-35 4-49 15-9 8-19 17-20 29h2c12-15 32-5 46 2h4c1-4-2-7-6-9 5 1 10-1 15-2 4-2 1-4 0-6-2-2-5-2-7-3-1-1-1-2-3-3 7-2 13-3 20-5 1-1 3-2 1-5ZM637 370c-2 0-5 0-4 3 3 13-4 26-13 34-19 15-42 15-64 17-17 1-33-3-50-2-10 1-20-3-24-13a7.78 7.78 0 0 1 2-8c6-6 14-9 22-10 12-1 24 6 36 4 1 0 3 1 5 0s4-4 5-6c2-10-3-19-4-29-1-14 2-28 12-38 10-9 20-17 33-22a3.67 3.67 0 0 0 1-3 3.49 3.49 0 0 0-2-1c-18 6-35 18-45 35-3 5-4 10-5 16-2 13 4 24 5 36 0 6-7 8-12 7-19-6-48-9-55 13-3 7-2 15 4 20 4 3 8 4 12 5 6 0 11 3 17 0 36 0 73 7 106-14 14-10 27-27 18-44Z"
            className="a"
        />
        <path
            d="M637 370c-2 0-5 0-4 3 3 13-4 26-13 34-19 15-42 15-64 17-17 1-33-3-50-2-10 1-20-3-24-13a7.78 7.78 0 0 1 2-8c6-6 14-9 22-10 12-1 24 6 36 4 1 0 3 1 5 0s4-4 5-6c2-10-3-19-4-29-1-14 2-28 12-38 10-9 20-17 33-22a3.67 3.67 0 0 0 1-3 3.49 3.49 0 0 0-2-1c-18 6-35 18-45 35-3 5-4 10-5 16-2 13 4 24 5 36 0 6-7 8-12 7-19-6-48-9-55 13-3 7-2 15 4 20 4 3 8 4 12 5 6 0 11 3 17 0 36 0 73 7 106-14 14-10 27-27 18-44Z"
            className="b"
        />
        <path
            d="M414 390a179.27 179.27 0 0 1-38 22c-3 1-6 1-9 3a9 9 0 0 1-5 1 7.58 7.58 0 0 1-4 2c-7 1-13 3-19 4a994.8 994.8 0 0 1-122 4c-3 0-7-1-9-4-3-3-4-9-1-11 38-28 84-18 127-22 24-3 44-12 65-25a37.38 37.38 0 0 0 13-15v-3h-2c-6 8-13 13-21 18l-3 3c-9 4-17 8-26 11-10 3-19 6-29 7-9 0-18 1-27 1-28-1-56 0-82 11h-3c-10 5-26 13-19 26 3 6 11 8 17 8 40 1 80 1 120-3 30-3 56-16 80-34a3.3 3.3 0 0 0 0-5c-1 0-2 1-3 1Z"
            className="a"
        />
        <path
            d="M414 390a179.27 179.27 0 0 1-38 22c-3 1-6 1-9 3a9 9 0 0 1-5 1 7.58 7.58 0 0 1-4 2c-7 1-13 3-19 4a994.8 994.8 0 0 1-122 4c-3 0-7-1-9-4-3-3-4-9-1-11 38-28 84-18 127-22 24-3 44-12 65-25a37.38 37.38 0 0 0 13-15v-3h-2c-6 8-13 13-21 18l-3 3c-9 4-17 8-26 11-10 3-19 6-29 7-9 0-18 1-27 1-28-1-56 0-82 11h-3c-10 5-26 13-19 26 3 6 11 8 17 8 40 1 80 1 120-3 30-3 56-16 80-34a3.3 3.3 0 0 0 0-5c-1 0-2 1-3 1Z"
            className="b"
        />
        <path
            d="M212 411c-9 1-17 2-26 1a114.22 114.22 0 0 1-26-9c-2-1-5-4-4-7 2-6 9-6 14-7 18-2 37 2 52-9-2 0-4-2-5-2-17 5-34 3-52 6-8 2-21 7-16 17 3 4 6 7 11 9 14 5 28 10 43 7 2-1 3-4 5-5 1-1 3-1 4-1Z"
            className="a"
        />
        <path
            d="M212 411c-9 1-17 2-26 1a114.22 114.22 0 0 1-26-9c-2-1-5-4-4-7 2-6 9-6 14-7 18-2 37 2 52-9-2 0-4-2-5-2-17 5-34 3-52 6-8 2-21 7-16 17 3 4 6 7 11 9 14 5 28 10 43 7 2-1 3-4 5-5 1-1 3-1 4-1Z"
            className="b"
        />
        <path
            d="M548 369c-1-1-1-3-2-4-16 16-37 26-60 24-25-3-50-6-75-6a3 3 0 0 0-2 4c3 3 8 2 12 3 7 1 13-2 20-1 37 6 81 12 107-20Z"
            className="a"
        />
        <path
            d="M548 369c-1-1-1-3-2-4-16 16-37 26-60 24-25-3-50-6-75-6a3 3 0 0 0-2 4c3 3 8 2 12 3 7 1 13-2 20-1 37 6 81 12 107-20Z"
            className="b"
        />
        <path
            d="M178 404c-5-1-10-3-15 1 0 1-1 1-1 2a3.49 3.49 0 0 0 2 1c5-2 9-2 14-2v-2Z"
            className="a"
        />
        <path
            d="M178 404c-5-1-10-3-15 1 0 1-1 1-1 2a3.49 3.49 0 0 0 2 1c5-2 9-2 14-2v-2Z"
            className="b"
        />
        <path
            d="M174 396c-7-2-19-5-22 4 3 0 5-2 7-3 5-1 9 2 14 1 1 0 1-1 1-2Z"
            className="a"
        />
        <path
            d="M174 396c-7-2-19-5-22 4 3 0 5-2 7-3 5-1 9 2 14 1 1 0 1-1 1-2Z"
            className="b"
        />
        <path
            d="M221 414c-6 0-12-1-17 2-3 1-2 4-2 6 3-2 6-5 10-5a27.69 27.69 0 0 0 9-1v-2Z"
            className="a"
        />
        <path
            d="M221 414c-6 0-12-1-17 2-3 1-2 4-2 6 3-2 6-5 10-5a27.69 27.69 0 0 0 9-1v-2Z"
            className="b"
        />
        <path
            d="M227 422c-4-2-8-1-12 1-2 1-7-1-6 6h2c4-6 11-2 16-5v-2Z"
            className="a"
        />
        <path
            d="M227 422c-4-2-8-1-12 1-2 1-7-1-6 6h2c4-6 11-2 16-5v-2Z"
            className="b"
        />
        <path
            d="M497 413c-4-2-9 0-13 1-1 1-1 4 0 3 7-3 14 1 21 0 0-4-5-4-8-4Z"
            className="a"
        />
        <path
            d="M497 413c-4-2-9 0-13 1-1 1-1 4 0 3 7-3 14 1 21 0 0-4-5-4-8-4Z"
            className="b"
        />
        <path
            d="M505 404c-7-2-19-7-23 2a66 66 0 0 1 14-1c3 0 7 5 10 0l-1-1Z"
            className="a"
        />
        <path
            d="M505 404c-7-2-19-7-23 2a66 66 0 0 1 14-1c3 0 7 5 10 0l-1-1Z"
            className="b"
        />
        <path
            d="M397 182c-2-11-11-19-20-24-14-7-30-1-40 11-1 2-2 3-3 5-7 13-5 29 2 42 4 7 9 17 18 19v-2c7-1 13 1 20 1 1-14 13-22 19-34a18.54 18.54 0 0 0 2-7c1-4 3-7 2-11ZM184 312a1 1 0 0 0-1-1c-1 5-5 8 0 14l1-1c0-1-1-1-1-2 0-3 3-6 1-10Z"
            className="a"
        />
        <path
            d="M184 312a1 1 0 0 0-1-1c-1 5-5 8 0 14l1-1c0-1-1-1-1-2 0-3 3-6 1-10Z"
            className="b"
        />
        <path d="m186 304-1-1c-2 2-1 4-1 6 2-1 2-3 2-5Z" className="a" />
        <path d="m186 304-1-1c-2 2-1 4-1 6 2-1 2-3 2-5Z" className="b" />
        <path d="M187 299c-2 0-1 1-1 2 2 0 1-1 1-2Z" className="a" />
        <path d="M187 299c-2 0-1 1-1 2 2 0 1-1 1-2Z" className="b" />
        <path
            d="M196 284c-3 3-6 5-8 9 0 1-2 4 1 3 1 0 0-2 1-3 4-2 5-6 7-9Z"
            className="a"
        />
        <path
            d="M196 284c-3 3-6 5-8 9 0 1-2 4 1 3 1 0 0-2 1-3 4-2 5-6 7-9Z"
            className="b"
        />
        <path
            d="M203 277a13.8 13.8 0 0 0-4 3c0 1 0 1 1 1 1-1 2-1 3-2v-2Z"
            className="a"
        />
        <path
            d="M203 277a13.8 13.8 0 0 0-4 3c0 1 0 1 1 1 1-1 2-1 3-2v-2Z"
            className="b"
        />
        <path
            d="M225 274c-1-1-2-3-3-4-1 0-2 0-2 1v-1a64.7 64.7 0 0 0 8 9 5.5 5.5 0 0 0-3-5Z"
            className="a"
        />
        <path
            d="M225 274c-1-1-2-3-3-4-1 0-2 0-2 1v-1a64.7 64.7 0 0 0 8 9 5.5 5.5 0 0 0-3-5Z"
            className="b"
        />
        <path d="M229 281h-1a3.67 3.67 0 0 0 1 3h2c1-1 1-2-2-3Z" className="a" />
        <path d="M229 281h-1a3.67 3.67 0 0 0 1 3h2c1-1 1-2-2-3Z" className="b" />
        <path d="M232 287h-1c0 1 1 1 1 2l1-1-1-1Z" className="a" />
        <path d="M232 287h-1c0 1 1 1 1 2l1-1-1-1Z" className="b" />
        <path
            d="M238 299c-1-2 0-7-4-7 3 6-1 13 3 18a41 41 0 0 1 1-11Z"
            className="a"
        />
        <path
            d="M238 299c-1-2 0-7-4-7 3 6-1 13 3 18a41 41 0 0 1 1-11Z"
            className="b"
        />
        <path d="M237 313c-3 0-1 3-2 4 3 0 1-3 2-4Z" className="a" />
        <path d="M237 313c-3 0-1 3-2 4 3 0 1-3 2-4Z" className="b" />
        <path d="M378 208c0 5-8 9-4 14 2-4 4-9 6-13 0-1-1-1-2-1Z" className="a" />
        <path d="M378 208c0 5-8 9-4 14 2-4 4-9 6-13 0-1-1-1-2-1Z" className="b" />
        <path
            d="M382 201a7.58 7.58 0 0 0-2 4l1 1c1-1 3-2 3-4a3.49 3.49 0 0 0-2-1Z"
            className="a"
        />
        <path
            d="M382 201a7.58 7.58 0 0 0-2 4l1 1c1-1 3-2 3-4a3.49 3.49 0 0 0-2-1Z"
            className="b"
        />
        <path d="M386 195c0 1-1 3-1 4a5.2 5.2 0 0 0 2-4Z" className="a" />
        <path d="M386 195c0 1-1 3-1 4a5.2 5.2 0 0 0 2-4Z" className="b" />
        <path d="M391 187h-2c-2 2-1 5-1 7 3-2 2-5 3-7Z" className="a" />
        <path d="M391 187h-2c-2 2-1 5-1 7 3-2 2-5 3-7Z" className="b" />
        <path
            d="M390 177c-1 0-2 0-2 1a9 9 0 0 0 1 5h2c1-2 0-4-1-6Z"
            className="a"
        />
        <path
            d="M390 177c-1 0-2 0-2 1a9 9 0 0 0 1 5h2c1-2 0-4-1-6Z"
            className="b"
        />
        <path d="M386 171h-1c0 1 1 2 2 3a3.67 3.67 0 0 0-1-3Z" className="a" />
        <path d="M386 171h-1c0 1 1 2 2 3a3.67 3.67 0 0 0-1-3Z" className="b" />
        <path d="M334 181c-1 4-4 8-1 12-1-4 4-8 1-12Z" className="a" />
        <path d="M334 181c-1 4-4 8-1 12-1-4 4-8 1-12Z" className="b" />
        <path d="m338 174-1-1c-1 2-2 3-2 5h2c1-1 1-3 1-4Z" className="a" />
        <path d="m338 174-1-1c-1 2-2 3-2 5h2c1-1 1-3 1-4Z" className="b" />
        <path d="M340 169c-1 1-2 1-2 2l1 1a3.67 3.67 0 0 0 1-3Z" className="a" />
        <path d="M340 169c-1 1-2 1-2 2l1 1a3.67 3.67 0 0 0 1-3Z" className="b" />
        <path d="M346 164c-1 0-3 1-3 2l1 1c1-1 2-2 3-2l-1-1Z" className="a" />
        <path d="M346 164c-1 0-3 1-3 2l1 1c1-1 2-2 3-2l-1-1Z" className="b" />
        <path d="M334 197c0-1 0-2-1-2l-1 1c0 1 0 4 2 3v-2Z" className="a" />
        <path d="M334 197c0-1 0-2-1-2l-1 1c0 1 0 4 2 3v-2Z" className="b" />
        <path d="M403 210c-1 1-2 1-2 2l1 1c1 0 2-2 2-3Z" className="a" />
        <path d="M403 210c-1 1-2 1-2 2l1 1c1 0 2-2 2-3Z" className="b" />
        <path
            d="M408 202c-1 1-3 2-4 4 0 1 0 2 1 2 2-1 3-3 4-5 0-1 0-1-1-1Z"
            className="a"
        />
        <path
            d="M408 202c-1 1-3 2-4 4 0 1 0 2 1 2 2-1 3-3 4-5 0-1 0-1-1-1Z"
            className="b"
        />
        <path d="M413 196c-1 1-2 1-2 2s1 1 2 1c0-1 1-1 1-2l-1-1Z" className="a" />
        <path d="M413 196c-1 1-2 1-2 2s1 1 2 1c0-1 1-1 1-2l-1-1Z" className="b" />
        <path
            d="M437 186c-7 1-15 0-20 7l1 1c2-1 5-4 7-4a50.67 50.67 0 0 0 13-2s0-2-1-2Z"
            className="a"
        />
        <path
            d="M437 186c-7 1-15 0-20 7l1 1c2-1 5-4 7-4a50.67 50.67 0 0 0 13-2s0-2-1-2Z"
            className="b"
        />
        <path
            d="M444 188c-1-1-2-2-3-2l-1 1a7.58 7.58 0 0 0 4 2v-1Z"
            className="a"
        />
        <path
            d="M444 188c-1-1-2-2-3-2l-1 1a7.58 7.58 0 0 0 4 2v-1Z"
            className="b"
        />
        <path d="M450 189c-1-1-2-2-3-1-1 2 2 2 3 2v-1Z" className="a" />
        <path d="M450 189c-1-1-2-2-3-1-1 2 2 2 3 2v-1Z" className="b" />
        <path d="M426 245c-1 0-5-5-4 1 1 1 3 1 4 1v-2Z" className="a" />
        <path d="M426 245c-1 0-5-5-4 1 1 1 3 1 4 1v-2Z" className="b" />
        <path d="M443 242c-4 3-10-2-12 4 4 0 9 0 13-2 0 0 1-2-1-2Z" className="a" />
        <path d="M443 242c-4 3-10-2-12 4 4 0 9 0 13-2 0 0 1-2-1-2Z" className="b" />
        <path d="m450 237-3 3a5.2 5.2 0 0 0 4-2c1-1 0-1-1-1Z" className="a" />
        <path d="m450 237-3 3a5.2 5.2 0 0 0 4-2c1-1 0-1-1-1Z" className="b" />
        <path d="M454 233a3.67 3.67 0 0 0-1 3c1-1 2-1 2-2l-1-1Z" className="a" />
        <path d="M454 233a3.67 3.67 0 0 0-1 3c1-1 2-1 2-2l-1-1Z" className="b" />
        <path
            d="M459 224c-2 0-1 3-3 4 0 1 1 2 2 1 1-2 3-4 2-6l-1 1Z"
            className="a"
        />
        <path
            d="M459 224c-2 0-1 3-3 4 0 1 1 2 2 1 1-2 3-4 2-6l-1 1Z"
            className="b"
        />
        <path
            d="M521 151a13 13 0 0 0-13 5c-1 1 0 1 1 1 2-2 4-3 8-3 2 0 4 0 4-3Z"
            className="a"
        />
        <path
            d="M521 151a13 13 0 0 0-13 5c-1 1 0 1 1 1 2-2 4-3 8-3 2 0 4 0 4-3Z"
            className="b"
        />
        <path d="M528 150c-1-1-3-1-5 0 1 2 3 1 5 1v-1Z" className="a" />
        <path d="M528 150c-1-1-3-1-5 0 1 2 3 1 5 1v-1Z" className="b" />
        <path d="M534 150h-3c0 1 1 1 2 1l1-1Z" className="a" />
        <path d="M534 150h-3c0 1 1 1 2 1l1-1Z" className="b" />
        <path
            d="M549 152a18.54 18.54 0 0 0-7-2c-1 0-4-5-4 1 4 0 7 2 10 3 1 0 1-1 1-2Z"
            className="a"
        />
        <path
            d="M549 152a18.54 18.54 0 0 0-7-2c-1 0-4-5-4 1 4 0 7 2 10 3 1 0 1-1 1-2Z"
            className="b"
        />
        <path
            d="M531 129c-5 5-12 5-15 13 4-3 8-6 13-8l3-3c0-1 1-2-1-2Z"
            className="a"
        />
        <path
            d="M531 129c-5 5-12 5-15 13 4-3 8-6 13-8l3-3c0-1 1-2-1-2Z"
            className="b"
        />
        <path
            d="M538 125c-1 1-3 1-4 2l1 1a5.2 5.2 0 0 0 4-2c1-1 0-1-1-1Z"
            className="a"
        />
        <path
            d="M538 125c-1 1-3 1-4 2l1 1a5.2 5.2 0 0 0 4-2c1-1 0-1-1-1Z"
            className="b"
        />
        <path d="M544 123c-1 0-3 0-3 1l1 1c1 0 2-1 3-2Z" className="a" />
        <path d="M544 123c-1 0-3 0-3 1l1 1c1 0 2-1 3-2Z" className="b" />
        <path d="M556 120a27.69 27.69 0 0 0-9 1l1 1c3-1 7 3 8-2Z" className="a" />
        <path d="M556 120a27.69 27.69 0 0 0-9 1l1 1c3-1 7 3 8-2Z" className="b" />
        <path d="M413 278c-2 0-1 1-1 2s0 2 2 2c0-1-1-3-1-4Z" className="a" />
        <path d="M413 278c-2 0-1 1-1 2s0 2 2 2c0-1-1-3-1-4Z" className="b" />
        <path
            d="M424 294c-2-2-4-4-5-7-1-1-2-3-4-3a19.91 19.91 0 0 0 8 12 3.49 3.49 0 0 1 2-1l-1-1Z"
            className="a"
        />
        <path
            d="M424 294c-2-2-4-4-5-7-1-1-2-3-4-3a19.91 19.91 0 0 0 8 12 3.49 3.49 0 0 1 2-1l-1-1Z"
            className="b"
        />
        <path
            d="M431 299c-1-1-2-3-4-2-1 1 0 2 1 3 1 0 1 1 2 1a3.49 3.49 0 0 0 1-2Z"
            className="a"
        />
        <path
            d="M431 299c-1-1-2-3-4-2-1 1 0 2 1 3 1 0 1 1 2 1a3.49 3.49 0 0 0 1-2Z"
            className="b"
        />
        <path
            d="M436 302c-1-1-1-2-2-2l-1 1c0 1 1 2 2 3 0-1 1-1 1-2Z"
            className="a"
        />
        <path
            d="M436 302c-1-1-1-2-2-2l-1 1c0 1 1 2 2 3 0-1 1-1 1-2Z"
            className="b"
        />
        <path
            d="M458 307h-4c-5-1-9-6-15-4v2c5 1 10 5 15 5 1 0 4 4 4-3Z"
            className="a"
        />
        <path
            d="M458 307h-4c-5-1-9-6-15-4v2c5 1 10 5 15 5 1 0 4 4 4-3Z"
            className="b"
        />
        <path d="M467 308c-2 0-4-1-5 1 2 1 3 2 5 1v-2Z" className="a" />
        <path d="M467 308c-2 0-4-1-5 1 2 1 3 2 5 1v-2Z" className="b" />
        <path d="M475 307c-1 0-3 0-3 1 0 6 3 1 4 1 0-1 1-2-1-2Z" className="a" />
        <path d="M475 307c-1 0-3 0-3 1 0 6 3 1 4 1 0-1 1-2-1-2Z" className="b" />
        <path
            d="M573 233c-3 3-8 5-11 8-1 1 1 2 1 2 4-3 10-4 11-10Z"
            className="a"
        />
        <path
            d="M573 233c-3 3-8 5-11 8-1 1 1 2 1 2 4-3 10-4 11-10Z"
            className="b"
        />
        <path
            d="M581 227c-2 1-3 2-5 3 0 1 1 1 1 2 1-2 4-2 5-3 0-1 1-2-1-2Z"
            className="a"
        />
        <path
            d="M581 227c-2 1-3 2-5 3 0 1 1 1 1 2 1-2 4-2 5-3 0-1 1-2-1-2Z"
            className="b"
        />
        <path d="m587 225-1-1c-1 0-2 1-3 2l1 1c1 0 3 0 3-2Z" className="a" />
        <path d="m587 225-1-1c-1 0-2 1-3 2l1 1c1 0 3 0 3-2Z" className="b" />
        <path d="M593 221a7.58 7.58 0 0 0-4 2l1 1c2-1 5 0 4-3Z" className="a" />
        <path d="M593 221a7.58 7.58 0 0 0-4 2l1 1c2-1 5 0 4-3Z" className="b" />
        <path
            d="M616 216c-6 0-14-2-18 4l1 1c1 0 3-2 4-2 5-1 10 1 14-2l-1-1Z"
            className="a"
        />
        <path
            d="M616 216c-6 0-14-2-18 4l1 1c1 0 3-2 4-2 5-1 10 1 14-2l-1-1Z"
            className="b"
        />
        <path
            d="M625 217c-2-1-3-2-5-1 0 0-1 2 1 2 1 1 3 1 4 1l1-1-1-1Z"
            className="a"
        />
        <path
            d="M625 217c-2-1-3-2-5-1 0 0-1 2 1 2 1 1 3 1 4 1l1-1-1-1Z"
            className="b"
        />
        <path d="M614 361c-1-1-5-2-5 1 2-1 4 1 5-1Z" className="a" />
        <path d="M614 361c-1-1-5-2-5 1 2-1 4 1 5-1Z" className="b" />
        <path d="M633 356c-5 2-11 2-16 4 6 3 12 0 17-3l-1-1Z" className="a" />
        <path d="M633 356c-5 2-11 2-16 4 6 3 12 0 17-3l-1-1Z" className="b" />
        <path d="M641 352c-2 1-6 2-5 4 2 1 4-2 6-2 0-1 1-2-1-2Z" className="a" />
        <path d="M641 352c-2 1-6 2-5 4 2 1 4-2 6-2 0-1 1-2-1-2Z" className="b" />
        <path d="m647 347-3 3 1 1a3.19 3.19 0 0 0 3-3l-1-1Z" className="a" />
        <path d="m647 347-3 3 1 1a3.19 3.19 0 0 0 3-3l-1-1Z" className="b" />
        <path
            d="M658 335c-1 3-5 4-7 7-1 1-1 3-1 4a24.1 24.1 0 0 0 10-10 3.49 3.49 0 0 0-2-1Z"
            className="a"
        />
        <path
            d="M658 335c-1 3-5 4-7 7-1 1-1 3-1 4a24.1 24.1 0 0 0 10-10 3.49 3.49 0 0 0-2-1Z"
            className="b"
        />
        <path d="M662 327c-1 2-1 3-2 5 3 1 3-2 4-4 0-1-1-1-2-1Z" className="a" />
        <path d="M662 327c-1 2-1 3-2 5 3 1 3-2 4-4 0-1-1-1-2-1Z" className="b" />
        <path d="M664 321c-2 1-2 3-1 4 3 1 2-2 3-4l-1-1-1 1Z" className="a" />
        <path d="M664 321c-2 1-2 3-1 4 3 1 2-2 3-4l-1-1-1 1Z" className="b" />
        <path d="M406 378a3.67 3.67 0 0 0-3-1c1 1 2 2 3 2v-1Z" className="a" />
        <path d="M406 378a3.67 3.67 0 0 0-3-1c1 1 2 2 3 2v-1Z" className="b" />
        <path
            d="M416 380c-2-1-5-2-7-1-2 0 2 1 2 2 1 1 3 1 4 1s1-1 1-2Z"
            className="a"
        />
        <path
            d="M416 380c-2-1-5-2-7-1-2 0 2 1 2 2 1 1 3 1 4 1s1-1 1-2Z"
            className="b"
        />
        <path
            d="M423 382c-1 0-2-1-3-1l-1 1c0 1 2 2 3 2a3.49 3.49 0 0 0 1-2Z"
            className="a"
        />
        <path
            d="M423 382c-1 0-2-1-3-1l-1 1c0 1 2 2 3 2a3.49 3.49 0 0 0 1-2Z"
            className="b"
        />
        <path
            d="M443 384c-4 1-7-2-11-2-2 0-4-1-5 1 0 1 3 2 4 2 2 0 4 1 7 2a9 9 0 0 0 5-1v-2Z"
            className="a"
        />
        <path
            d="M443 384c-4 1-7-2-11-2-2 0-4-1-5 1 0 1 3 2 4 2 2 0 4 1 7 2a9 9 0 0 0 5-1v-2Z"
            className="b"
        />
        <path
            d="M452 384c-1 0-2-1-3-1l-1 1c0 1 2 2 3 2 2 0 1-1 1-2Z"
            className="a"
        />
        <path
            d="M452 384c-1 0-2-1-3-1l-1 1c0 1 2 2 3 2 2 0 1-1 1-2Z"
            className="b"
        />
        <path d="M461 383h-4c-1 1 1 2 2 2h2v-2Z" className="a" />
        <path d="M461 383h-4c-1 1 1 2 2 2h2v-2Z" className="b" />
        <path d="M584 162c-3 1-6-5-9-2 3 1 5 4 8 4 1 0 1-1 1-2Z" className="a" />
        <path d="M584 162c-3 1-6-5-9-2 3 1 5 4 8 4 1 0 1-1 1-2Z" className="b" />
        <path d="M590 168c-1-1-2-5-4-4-1 2 2 4 3 5s1 0 1-1Z" className="a" />
        <path d="M590 168c-1-1-2-5-4-4-1 2 2 4 3 5s1 0 1-1Z" className="b" />
        <path d="M595 171c-1-1-2-3-4-2-1 2 2 2 3 3l1-1Z" className="a" />
        <path d="M595 171c-1-1-2-3-4-2-1 2 2 2 3 3l1-1Z" className="b" />
        <path
            d="M604 183c-2-4-3-8-7-10a3.49 3.49 0 0 1-2 1c2 2 4 4 5 7 1 1 2 3 4 3v-1Z"
            className="a"
        />
        <path
            d="M604 183c-2-4-3-8-7-10a3.49 3.49 0 0 1-2 1c2 2 4 4 5 7 1 1 2 3 4 3v-1Z"
            className="b"
        />
        <path d="M609 190c-1-2 0-5-4-3 0 0 1 4 4 4v-1Z" className="a" />
        <path d="M609 190c-1-2 0-5-4-3 0 0 1 4 4 4v-1Z" className="b" />
        <path d="M620 141c-2-3-4-7-7-9l-1 1c1 4 4 6 7 9l1-1Z" className="a" />
        <path d="M620 141c-2-3-4-7-7-9l-1 1c1 4 4 6 7 9l1-1Z" className="b" />
        <path d="M623 143c-2 0-1 1-1 2s0 2 2 2l1-1c0-1-1-2-2-3Z" className="a" />
        <path d="M623 143c-2 0-1 1-1 2s0 2 2 2l1-1c0-1-1-2-2-3Z" className="b" />
        <path
            d="M631 153c-1-1-2-3-4-4-1 0-2 0-2 1l3 3c2 4 1 9 5 11l1-1c-1-4-2-7-3-10Z"
            className="a"
        />
        <path
            d="M631 153c-1-1-2-3-4-4-1 0-2 0-2 1l3 3c2 4 1 9 5 11l1-1c-1-4-2-7-3-10Z"
            className="b"
        />
        <path d="m635 166-1 1c0 1 0 4 2 3 1-1-1-3-1-4Z" className="a" />
        <path d="m635 166-1 1c0 1 0 4 2 3 1-1-1-3-1-4Z" className="b" />
        <path
            d="M638 174c-1-1-1-2-2-2l-1 1c2 1 1 3 1 4 1 0 2 0 2-3Z"
            className="a"
        />
        <path
            d="M638 174c-1-1-1-2-2-2l-1 1c2 1 1 3 1 4 1 0 2 0 2-3Z"
            className="b"
        />
        <path d="M638 181c-2 0-1 1-1 2l1 1v-3Z" className="a" />
        <path d="M638 181c-2 0-1 1-1 2l1 1v-3Z" className="b" />
        <path d="M638 188h-2c2 4-3 7 0 11 3-3 2-7 2-11Z" className="a" />
        <path d="M638 188h-2c2 4-3 7 0 11 3-3 2-7 2-11Z" className="b" />
        <path
            d="m120 482-1-1c-1 0-1 1-2 1"
            style={{
                fill: "#b59c7a",
            }}
        />
    </svg>
)
export default HundIcon

